var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading",
        },
      ],
      staticClass: "aiDetail",
    },
    [
      _c("div", { staticClass: "aiDetailHeader" }, [
        _c("img", {
          attrs: { src: require("@/assets/image/aigc/close.png"), alt: "" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
        !_vm.form.isPrivate && !_vm.form.isDeleted
          ? _c("img", {
              attrs: { src: require("@/assets/image/aigc/aiShare.png") },
              on: { click: _vm.onhandleShare },
            })
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "ailist_view_img" },
        [
          _vm.isScene.type === "AI"
            ? _c("img", {
                attrs: {
                  src: require("@/assets/image/aigc/my_icon.png"),
                  alt: "",
                },
              })
            : [
                !!_vm.form.icon
                  ? _c("img", { attrs: { src: _vm.form.icon, alt: "" } })
                  : _c(
                      "div",
                      {
                        staticClass: "title-span",
                        style: { background: _vm.form.backgroundColor },
                      },
                      [
                        _c("span", { style: { color: _vm.form.textColor } }, [
                          _vm._v(_vm._s(_vm.form.title.split("")[0])),
                        ]),
                      ]
                    ),
              ],
        ],
        2
      ),
      _c("div", { staticClass: "aiDetail_title" }, [
        _vm._v(
          " " +
            _vm._s(_vm.form.templateId === "1" ? "智云" : _vm.form.title) +
            " "
        ),
      ]),
      _c("div", { staticClass: "aiDetail_describe" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.form.templateId === "1"
                ? "全能AI小助手，解决你的所有问题"
                : _vm.form.description
            ) +
            " "
        ),
      ]),
      _c("div", { staticClass: "ailist_detail_footer" }, [
        _c("div", { staticClass: "ailist_detail_footer_des" }, [
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/aiCreater.png") },
            }),
            _c("span", [_vm._v(_vm._s(_vm.form.createdNickName))]),
          ]),
          _c("div", [
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/aiHot.png") },
            }),
            _c("span", [_vm._v(_vm._s(_vm.form.useCounter))]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }